
/*

Breakpoint

Retrieve media query result similar to SCSS breakpoint include.

Min-width and up:

Ex: if(window.SETTINGS.breakpoint.minWidth('screen-small')){ doStuff(); }

Max-width and down:

Ex: if(window.SETTINGS.breakpoint.maxWidth('screen-small')){ doStuff(); }

Last edited 04.14.17 by David Robbins

*/

class Breakpoint {

	constructor(params){
		this.breakpoints = params.breakpoints;
		this._init();
	}

	_init(){
		this._addListeners();
	}

	_addListeners(){

	}

	minWidth(breakpoint, isTouch){

		let breakpointValue = this.getBreakpointValue(breakpoint) + 1;

		if(Modernizr.mq('(min-width:' + breakpointValue + 'px)') && this.checkTouch(isTouch)){
			return true;
		}

		return false;
	}

	maxWidth(breakpoint, isTouch){

		let breakpointValue = this.getBreakpointValue(breakpoint);

		if(Modernizr.mq('(max-width:' + breakpointValue + 'px)') && this.checkTouch(isTouch)){
			return true;
		}

		return false;
	}

	minHeight(breakpoint, isTouch){

		let breakpointValue = this.getBreakpointValue(breakpoint, true) + 1;

		if(Modernizr.mq('(min-height:' + breakpointValue + 'px)') && this.checkTouch(isTouch)){
			return true;
		}

		return false;
	}

	maxHeight(breakpoint, isTouch){

		let breakpointValue = this.getBreakpointValue(breakpoint, true);

		if(Modernizr.mq('(max-height:' + breakpointValue + 'px)') && this.checkTouch(isTouch)){
			return true;
		}

		return false;
	}

	getBreakpointValue(breakpoint){

		let breakpointValue = false;

		if(isNaN(breakpoint)){

			let obj = _.findWhere(this.breakpoints, {id: breakpoint});

			if(typeof(obj.value) !== 'undefined'){
				breakpointValue = obj.value;
			}
		}
		else {
			breakpointValue = parseInt(breakpoint);
		}

		return breakpointValue;
	}

	checkTouch(isTouch){

		let supportsTouch = $('html').hasClass('supports-touchevents');

		if(isTouch === true){
			if(supportsTouch){ return true; }
			return false;
		}
		else if(isTouch === false){
			if(!supportsTouch){ return true; }
			return false;
		}

		return true;
	}
}

module.exports = Breakpoint;
